module.exports = __webpack_public_path__ + "img/gallery10.cf3afe5b.png";